import ls from "local-storage";
import { useHistory, useParams } from "react-router-dom";
import GovGrButton from "../../../components/GovGrButton";
import {
  GOVGR_BODY,
  GOVGR_GRID_COLUMN_TWO_THIRDS,
  GOVGR_HEADING_XL,
  GOVGR_MAIN_WRAPPER,
  GOVGR_WIDTH_CONTAINER,
} from "../../../conf/styles/Login";
import {
  IDENTIFICATION_REQUIRED_DEFAULT_MESSAGE,
  LOCAL_STORAGE_KEY_NAME_APPLKINDID,
  LOCAL_STORAGE_KEY_NAME_FOR_ME,
  LOGIN_DEFAULT_LABEL,
  TAXIS_LOGIN_PAGE_URL,
  YOU_NEED_TO_LOGIN_DEFAULT_MESSAGE,
} from "./constants";

const LoginComponent = () => {
  const history = useHistory();
  const params = useParams();

  const handleLogin = () => {
    if (Object.keys(params).length == 0) {
      // console.log("handleLogin");
      // console.log(params.applKindId);
      if (params.applKindId) {
        ls(LOCAL_STORAGE_KEY_NAME_APPLKINDID, params.applKindId);
      }
      if (params.forMe) {
        ls(LOCAL_STORAGE_KEY_NAME_FOR_ME, params.forMe);
      }
    }
    // console.log(TAXIS_LOGIN_PAGE_URL);
    history.push(TAXIS_LOGIN_PAGE_URL);
  };

  return (
    <div className={GOVGR_WIDTH_CONTAINER}>
      <div className={GOVGR_MAIN_WRAPPER}>
        <main className={GOVGR_GRID_COLUMN_TWO_THIRDS}>
          <h1 className={GOVGR_HEADING_XL}>
            {IDENTIFICATION_REQUIRED_DEFAULT_MESSAGE}
          </h1>
          <p className={GOVGR_BODY}>{YOU_NEED_TO_LOGIN_DEFAULT_MESSAGE}</p>
          <GovGrButton
            hasImage
            buttonText={LOGIN_DEFAULT_LABEL}
            onClick={handleLogin}
          />
        </main>
      </div>
    </div>
  );
};

export default LoginComponent;
